// Packages
import axios, { AxiosError } from "axios";
import { toNamespacedPath } from "node:path/win32";
import { FormEvent, useEffect, useState, useContext } from "react";
import { toast } from "react-toastify";

// Components
import { loginApi, generateOTPApi, CSRFToken } from "../services/auth";
import TOTP from "../components/totp";
import { useNavigate } from "react-router-dom";

// CSS
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../context/authprovider";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [loginResponse, setLoginResponse] = useState({});
  const { isAuthenticated } = useAuth()
  let navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/")
    }
  })

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("username", username);
    formData.append("password", password);

    try {
      const response = await loginApi(formData);
        if (response.status === 200) {
          //Display Modal && Generate OTP
          setLoginResponse(response.data);
          setOpenModal(true)
          try{
            await generateOTPApi(username);
        } catch (error) {
          toast.error("An error has occurred, please contact the Admin")
        }
      } else {
        toast.error("An error occured when you tried to login")
      }
    } catch (e) {
      if (e instanceof AxiosError && e.response && e.response.status === 400) {
        toast.error("Invalid email or password");
      } else if (e instanceof AxiosError && e.response && e.response.status === 403) {
        toast.error(e.response.data.message)
      }
    }
  };

  const registerRedirect = () => {
    navigate("/register");
  };

  return (
    <>
      {openModal && <TOTP onToggle={setOpenModal} loginRes={loginResponse} user={username} />}
      <div className="mt-20 min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <img
            className="mx-auto h-12 w-auto"
            src="https://tailwindui.com/img/logos/workflow-mark-indigo-600.svg"
            alt="Workflow"
          />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            AskMeAnything
          </h2>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <form className="space-y-6" onSubmit={handleSubmit}>
              <CSRFToken />
              {/* 3r660OmdONwBrU0ZWyCrhNCL6WplTOUE */}
              {/* <input type='hidden' name='csrfmiddlewaretoken' value='qwdoqoijdqoijoaisjdoiqjwoidj' /> */}
              <div>
                <label
                  htmlFor="username"
                  className="block text-sm font-medium text-gray-700"
                >
                  Username
                </label>
                <div className="mt-1">
                  <input
                    id="username"
                    name="username"
                    type="text"
                    autoComplete="username"
                    onChange={(e) => setUsername(e.target.value)}
                    required
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  />
                </div>
              </div>

              <div>
                <label
                  htmlFor="password"
                  className="block text-sm font-medium text-gray-700"
                >
                  Password
                </label>
                <div className="mt-1">
                  <input
                    id="password"
                    name="password"
                    type="password"
                    autoComplete="current-password"
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  />
                </div>
              </div>

              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <input
                    id="remember-me"
                    name="remember-me"
                    type="checkbox"
                    className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                  />
                  <label
                    htmlFor="remember-me"
                    className="ml-2 block text-sm text-gray-900"
                  >
                    Remember me
                  </label>
                </div>

                <div className="text-sm">
                  <a
                    href="/resetpassword"
                    className="font-medium text-indigo-600 hover:text-indigo-500"
                  >
                    Forgot your password?
                  </a>
                </div>
              </div>

              <div>
                <button
                  type="submit"
                  className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  Sign in
                </button>
              </div>
            </form>

            <div className="mt-6">
              <div className="relative">
                <div className="absolute inset-0 flex items-center">
                  <div className="w-full border-t border-gray-300" />
                </div>
              </div>
              <br />
              <div>
                <button
                  onClick={registerRedirect}
                  className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                >
                  Create New Account
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
